import React from "react";
import { Redirect } from "react-router-dom";

import { POLICY_QUERY } from "@/graphql/policies/policy";
import useDocTitle from "@/hooks/use-doc-title";
import { useQuery } from "@apollo/client";
import PropTypes from "prop-types";
import CustomerPage from "./CustomerPage";
import Box from "./Box";
import { useTheme } from "styled-components";
import { HeadingExtraExtraLarge } from "./Headings";
import RichText from "./RichText";
import classes from "./PolicyPage.module.scss";
import B2CHeader from "@/tpo/header/B2CHeader";

function PolicyPage({ slug }) {
    const theme = useTheme();
    const { data, loading } = useQuery(POLICY_QUERY, {
    variables: { slug }
    });

  const policy = data?.policy;
  const title = policy?.title || "";
  const content = policy?.content || "";

  useDocTitle(title);

  if (!loading && !policy) {
    return <Redirect to="/404" />;
  }

  return (
    <>
      <B2CHeader />
      <CustomerPage>
      <Box pt={theme.spacing.pageHeader.pt} px={20} pb={theme.spacing.section.pb}>
        <Box px={20}>
          <Box maxWidth={720} mb={50} mx="auto">
            <HeadingExtraExtraLarge as="h1" textAlign="center" pt={theme.spacing.large} pb={theme.spacing.medium}>
              {title}
            </HeadingExtraExtraLarge>
            <RichText className={classes.richText}>{content}</RichText>
          </Box>
        </Box>
      </Box>
    </CustomerPage>
    </>
  );
}

PolicyPage.propTypes = {
  slug: PropTypes.string.isRequired
};

export default PolicyPage;
